export const LEVEL2 = {
  EU: {
    config: {
      level2: '88',
    },
  },
  CA: {
    config: {
      level2: '88',
    },
  },
  US: {
    config: {
      level2: '88',
    },
  },
};
export const UNIVERSE = 'hub';
export const SUB_UNIVERSE = 'app';
export const APP_NAME = '';
